import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GET, PUT, httpOk } from 'helpers/api'
import { formatDate } from 'helpers/helpers'

// Ega ishlab chiqarish rahbari topshirgan hisobotlarni ko'radi va tasdiqlaydi.
function ManagerReports() {
	const { t } = useTranslation()

	const [reports, setReports] = useState([])
	const [ownerNotes, setOwnerNotes] = useState({})   // { [id]: text }
	const [busy, setBusy] = useState(null)

	async function load() {
		const res = await GET('/manager-reports', {}, { loader: true })
		if (httpOk(res)) setReports(res.data.data || [])
	}

	useEffect(() => { load() }, [])

	async function markReviewed(r) {
		setBusy(r.id)
		const res = await PUT(`/manager-reports/${r.id}/review`, { owner_note: ownerNotes[r.id] || '' }, { loader: false })
		setBusy(null)
		if (httpOk(res)) load()
	}

	const periodLabel = (p) => (p === 'shift' ? t('period_shift') : p === 'weekly' ? t('period_weekly') : t('period_daily'))

	return (
		<>
			<div className="page-header">
				<h4 className="mb-0">{t('manager_reports')}</h4>
			</div>

			{reports.length === 0 &&
				<div className="card"><div className="card-body text-center text-muted py-5">{t('list_empty')}</div></div>
			}

			<div className="d-flex flex-column gap-3">
				{reports.map((r) => (
					<div className="card" key={r.id}>
						<div className="card-body">
							<div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
								<div>
									<span className="fw-bold">{r.manager_name || r.manager_login}</span>
									<span className="badge bg-light text-dark ms-2">{periodLabel(r.period_type)}</span>
									<span className="text-muted ms-2">{formatDate(r.report_date, 'dd.MM.yyyy')}</span>
								</div>
								{Number(r.status) === 2
									? <span className="badge bg-success"><i className="uil-check me-1"></i>{t('status_reviewed')}</span>
									: <span className="badge bg-warning text-dark">{t('status_submitted')}</span>}
							</div>

							{/* Bo'lim raqamlari (snapshot) */}
							{Array.isArray(r.metrics) && r.metrics.length > 0 &&
								<div className="d-flex flex-wrap gap-2 mb-2">
									{r.metrics.map((m, i) => (
										<span key={i} className="border rounded px-2 py-1 small">
											<b>{m.name}</b> · {t('active_orders')}: {m.active_orders}
											{m.late > 0 && <span className="text-danger ms-1">· {t('late_orders')}: {m.late}</span>}
										</span>
									))}
								</div>
							}

							<div className="p-2 rounded mb-2" style={{ background: '#f8f9fa', whiteSpace: 'pre-wrap' }}>{r.note}</div>

							{/* Ega izohi + tasdiqlash */}
							{Number(r.status) === 2
								? (r.owner_note &&
									<div className="p-2 rounded small" style={{ background: '#e8f0fe' }}>
										<b>{t('owner_note')}:</b> {r.owner_note}
									</div>)
								: <div className="d-flex gap-2">
									<input type="text" className="form-control form-control-sm"
										placeholder={t('owner_note')}
										value={ownerNotes[r.id] || ''}
										onChange={(e) => setOwnerNotes({ ...ownerNotes, [r.id]: e.target.value })} />
									<button className="btn btn-sm btn-primary text-nowrap"
										disabled={busy === r.id}
										onClick={() => markReviewed(r)}>
										<i className="uil-check me-1"></i>{t('mark_reviewed')}
									</button>
								</div>
							}
						</div>
					</div>
				))}
			</div>
		</>
	)
}

export default ManagerReports
